import React from "react";
export const CryptoDisclaimer = ({ content }) => (React.createElement("p", { className: 'crypto-disclaimer' }, content));
